import React, { useState } from 'react';
import { MetaPixel } from './components/analytics/MetaPixel';
import { SocialProofNotification } from './components/SocialProofNotification';
import { StickyCta } from './components/StickyCta';
import { OfferId } from './components/offers/offerData';
import { Bonos } from './components/sections/Bonos';
import { Comparison } from './components/sections/Comparison';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
import { ForWhom } from './components/sections/ForWhom';
import { Guarantee } from './components/sections/Guarantee';
import { Hero } from './components/sections/Hero';
import { MegapackUpsell } from './components/sections/MegapackUpsell';
import { PainPoints } from './components/sections/PainPoints';
import { Pricing } from './components/sections/Pricing';
import { SystemBanner } from './components/sections/SystemBanner';
import { Testimonials } from './components/sections/Testimonials';
import { Tomos } from './components/sections/Tomos';
export function App() {
  const [selectedOffer, setSelectedOffer] = useState<OfferId>('megapack');
  return <main className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="3rcj7q5oi4587">
      <MetaPixel pixelId="1277802684248985" data-id="element-1" data-mp="3rd19tixuhdo1" />
      <Hero data-id="element-2" data-mp="6hqffdy0fe4" />
      <Testimonials data-id="element-3" data-mp="6801qozk67w" />
      <PainPoints data-id="element-4" data-mp="4n7u7q58zd7" />
      <ForWhom data-id="element-5" data-mp="82lr78302d1" />
      <SystemBanner data-id="element-6" data-mp="7sxbo2oq39g" />
      <Tomos data-id="element-7" data-mp="2zllff2q1qmn9" />
      <Bonos data-id="element-8" data-mp="2zlv8iz6e19x6" />
      <Comparison data-id="element-9" data-mp="2zmeoiach9o8k" />
      <Pricing selectedOffer={selectedOffer} onSelectOffer={setSelectedOffer} data-id="element-10" data-mp="2zmwguvw0rib7" />
      <MegapackUpsell data-id="element-11" data-mp="33nggq77z9011" />
      <Guarantee data-id="element-12" data-mp="33ori60dy9voz" />
      <Faq data-id="element-13" data-mp="38lromcepp0gm" />
      <FinalCta selectedOffer={selectedOffer} onSelectOffer={setSelectedOffer} data-id="element-14" data-mp="38m1elzzrb7mb" />
      <Footer data-id="element-15" data-mp="38o4fjf2g6l5t" />
      <SocialProofNotification data-id="element-16" data-mp="3dkl4ucldv5kh" />
      <StickyCta selectedOffer={selectedOffer} data-id="element-17" data-mp="3dlw4c07spr5s" />
    </main>;
}